import React, { useEffect, useState } from 'react';
import {Link} from "react-router-dom";
import {Button, ButtonToolbar, OverlayTrigger, Tooltip} from "react-bootstrap";
import {toast} from "react-toastify";
import Pagination from "../../assets/Pagination";
import BielletterieAPI from "../../../apis/adminApi/bielleterieAPI";
import TableLoader from "../../loaders/TableLoader";

const DailyAdminSpents = () => {

    const [dailySpents, setDailySpents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");

    const getAllSpents = async () => {
        try{
            const data =  await BielletterieAPI.dailySpents();
            setDailySpents(data.spents);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des depenses !");
        }
    };

    useEffect(() => {
        getAllSpents();
    },[]);


    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des buses en fonction de la recherche

    const filteredSpents = dailySpents.filter(
        b =>
            b.name.toLowerCase().includes(search.toLowerCase()) ||
            b.pos_name.toLowerCase().includes(search.toLowerCase()) ||
            b.spent_items[0].title.toLowerCase().includes(search.toLowerCase()) ||
            b.pos_city.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedSpents = Pagination.getData(
        filteredSpents,
        currentPage,
        itemsPerPage
    );


    const tooltip = (data) => (
        <Tooltip className="" id="tooltip">
            <ul className="list-group">
                {data && data.map((sp, index) => (<li key={index}>{sp.title} - {sp.amount} {sp.currency}</li>))}
            </ul>
        </Tooltip>
    );

    const handleDelete = async id => {
        try{
            await BielletterieAPI.deleteSpent(id);
            toast.success("La depense a bien été supprimée !");
            window.location.reload();
        }catch(error){
            toast.error("Erreur lors de la suppression de la facture !");
        }
    };


    let counter = 1;

    function calculTotal(data) {
        let tUSD = 0;
        let tCDF = 0;
        data.map((spent) => tCDF += spent.totalCDF);
        data.map((spent) => tUSD += spent.totalUSD);
        return {tCDF, tUSD}
    }



    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <h2 className="card-title">
                                        Mes bus - Total : <b className="text-primary">{paginatedSpents ? paginatedSpents.length : 0} </b>
                                    </h2>
                                </div>
                                <div className="col-md-6">
                                    <h2 className="card-title">Total depense du jour</h2>
                                    <h3><b>{calculTotal(paginatedSpents).tUSD} USD | {calculTotal(paginatedSpents).tCDF} CDF</b></h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Recherche par vendeur , agence ou ville
                                        </label>
                                        <input type="text"
                                               onChange={handleSearch}
                                               value={search}
                                               name="ByAll"
                                               autoComplete="off"
                                               id="ByAll"
                                               className="form-control"
                                               placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                {/*<div className="col-md-5">*/}
                                    {/*<div className="form-group mt-4 d-flex float-end">*/}
                                        {/*<PrintComponent type="billet" critere={search} data={filteredAllTikets} />*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            </div>
                            <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Vendeur</th>
                                    <th scope="col">Agence</th>
                                    <th scope="col">Ville</th>
                                    <th scope="col">Total USD</th>
                                    <th scope="col">Total CDF</th>
                                    <th scope="col">Intitulé</th>
                                    <th scope="col">Options</th>
                                </tr>
                                </thead>
                                {!loading && <tbody>
                                {paginatedSpents.map((spent) => (
                                        <tr key={spent.id}>
                                            <th scope="row">{counter++}</th>
                                            <td>{spent.name}</td>
                                            <td>{spent.pos_name}</td>
                                            <td>{spent.pos_city}</td>
                                            <td>{spent.totalUSD} $</td>
                                            <td>{spent.totalCDF} FC</td>
                                            <td>
                                                <ul className="list-group">
                                                    {spent.spent_items && spent.spent_items.map((sp, index) => (<li key={index}>{sp.title} - <b>{sp.amount} {sp.currency}</b></li>))}
                                                </ul>
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        if (window.confirm('Etes-vous sûr(e) de vouloir effectuer cette action ?')) {
                                                            handleDelete(spent.id)
                                                        }
                                                    }}
                                                    className="btn btn-sm btn-danger">
                                                    Supprimer
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                }

                                </tbody>}
                            </table>

                            {loading && <TableLoader width={300} height={350} />}

                            {itemsPerPage < filteredSpents.length &&
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                length={filteredSpents.length}
                                onPageChange={handleChangeCurrentPage}
                            />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DailyAdminSpents;
